import React, { useState } from "react";
import { Tab } from "@mui/material";
import { ScrollableTabs } from "./CustomMUIComponents";

const HalfDonutChart = ({ months, setradialBardata }) => {
  const [selectedTab, setSelectedTab] = useState(3);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    const item = months[newValue];

    setradialBardata((prev) => ({
      ...prev,
      series: [item.value],
      options: {
        ...prev?.options,
        labels: [`${item?.progressDifference}`],
        plotOptions: {
          ...prev?.plotOptions,
          radialBar: {
            ...prev?.plotOptions?.radialBar,
            dataLabels: {
              ...prev?.dataLabels,
              name: {
                ...prev?.dataLabels?.name,
                formatter: (val) => {
                  return `${val}% ${item?.progressDifference > 0 ? "↑" : "↓"}`;
                },
                color:
                  item?.progressDifference > 0
                    ? "#42BD53"
                    : item?.progressDifference < 0
                    ? "#FF0000"
                    : "grey",
              },
            },
          },
        },
      },
    }));
  };

  return (
    <ScrollableTabs
      value={selectedTab}
      onChange={handleTabChange}
      variant="scrollable"
    >
      {months.map((item, index) => (
        <Tab key={index} label={item.month} />
      ))}
    </ScrollableTabs>
  );
};

export default HalfDonutChart;
